import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';

import berryIcon from '../../lib/libraries/extensions/berry/berry-icon.svg';
import githubIcon from './github-icon.svg';

import styles from './berry-extension-hub-modal.css';

class BerryExtensionHubModal extends React.PureComponent {
    constructor (props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpenIssues = this.handleOpenIssues.bind(this);
    }
    handleClose () {
        this.props.onRequestClose();
    }
    handleOpenIssues () {
        window.open('https://github.com/berry-editor/extensions/issues', '_blank', 'noopener');
        this.props.onRequestClose();
    }
    render () {
        return (
            <ReactModal
                isOpen
                className={styles.modalContent}
                contentLabel="BerryEditor 扩展库"
                overlayClassName={styles.modalOverlay}
                onRequestClose={this.handleClose}
            >
                <div className={styles.modalHeader}>
                    <div className={styles.modalHeaderContent}>
                        <img
                            className={styles.headerIcon}
                            src={berryIcon}
                            draggable={false}
                            alt=""
                        />
                        <h2 className={styles.headerTitle}>
                            {'BerryEditor 扩展库'}
                        </h2>
                    </div>
                </div>
                <div className={styles.modalBody}>
                    {/* 须知 */}
                    <div className={styles.stepsSection}>
                        <h3 className={styles.sectionTitle}>
                            {'须知'}
                        </h3>
                        <p className={styles.sectionDesc}>
                            {'我们采取 "Issues" 的方式让您更方便的提交扩展。这需要你在提交扩展前有一个 GitHub 账号，对于如何注册，请自行百度，这里不再赘述。'}
                        </p>
                    </div>

                    {/* 准备 */}
                    <div className={styles.stepsSection}>
                        <h3 className={styles.sectionTitle}>
                            {'准备'}
                        </h3>
                    </div>

                    {/* 审核 */}
                    <div className={styles.stepsSection}>
                        <h3 className={styles.sectionTitle}>
                            {'审核'}
                        </h3>
                        <p className={styles.sectionDesc}>
                            {'在您提交一个扩展前，务必确保您的扩展可以正确运行。我们会对您提交的扩展展开审核，包括但不限于：'}
                        </p>
                        <ul className={styles.checkList}>
                            <li className={styles.checkItem}>{'扩展可以正确加载'}</li>
                            <li className={styles.checkItem}>{'所有添加的积木均可正确使用'}</li>
                            <li className={styles.checkItem}>{'不包含关于歧视、污秽语言、网络烂梗等语言、功能'}</li>
                            <li className={styles.checkItem}>{'没有过分的AI程度（100%由AI制作）'}</li>
                            <li className={styles.checkItem}>{'您能完全理解您编写的扩展（每一行代码）'}</li>
                        </ul>
                        <p className={styles.sectionDesc}>
                            {'审核的日期不定，但大多都能在一周内审核完成，请及时关注结果。'}
                        </p>
                    </div>

                    {/* 打包 */}
                    <div className={styles.stepsSection}>
                        <h3 className={styles.sectionTitle}>
                            {'打包'}
                        </h3>
                        <p className={styles.sectionDesc}>
                            {'您需要保证您提交的文件可以让别人看懂。我们规定了一个简单的目录，方便你我更快的检查和加入您的扩展：'}
                        </p>
                        <div className={styles.codeBlock}>
                            <pre>{'扩展名.zip\n    |- main.js      #您的扩展文件\n    |- featured.png #扩展的头图，在扩展库显示(你也可以上传svg格式的图片)\n    |- text.json    #存放您的扩展信息'}</pre>
                        </div>
                        <p className={styles.sectionDesc}>
                            {'确保文件名正确。如果您提交的不满足我们的要求，我们可能会拒绝加入您的扩展。'}
                        </p>
                        <p className={styles.sectionDesc}>
                            {'下面我们会展开每个文件具体的规范。'}
                        </p>
                    </div>

                    {/* main.js */}
                    <div className={styles.stepsSection}>
                        <h3 className={styles.sectionTitle}>
                            {'main.js'}
                        </h3>
                        <p className={styles.sectionDesc}>
                            {'这里存放您的扩展主文件，具体扩展该如何编写请参考其它扩展教程。'}
                        </p>
                        <p className={styles.sectionDesc}>
                            {'说回来，您的扩展开头应有以下内容：'}
                        </p>
                        <div className={styles.codeBlock}>
                            <pre>{'// Name: 扩展名称\n// ID: 扩展ID\n// Description: 扩展描述\n// By: 作者 <链接>\n// By: 更多作者 <链接> (可选, 可添加更多个)\n// License: 许可证（MIT、GPLv3等）'}</pre>
                        </div>
                        <p className={styles.sectionDesc}>
                            {'这在此扩展库是强制的，因为它涉及到实际的显示。'}
                        </p>
                        <p className={styles.sectionDesc}>
                            {'我们需要您将 Name 和 Description 写为英文，这需要作为默认文本于扩展库显示。'}
                        </p>
                        <p className={styles.sectionDesc}>
                            {'注意，对于多作者要用多个 // By: 而不是逗号。'}
                        </p>
                        <p className={styles.sectionDesc}>
                            {'此外，我们不要求您的内容包含国际化。'}
                        </p>
                    </div>

                    {/* featured.png(.svg) */}
                    <div className={styles.stepsSection}>
                        <h3 className={styles.sectionTitle}>
                            {'featured.png(.svg)'}
                        </h3>
                        <p className={styles.sectionDesc}>
                            {'这里是扩展的头图，也就是在扩展库展示的图片。我们硬性要求扩展图满足以下条件：'}
                        </p>
                        <ul className={styles.checkList}>
                            <li className={styles.checkItem}>{'纵横比为 2:1'}</li>
                            <li className={styles.checkItem}>{'分辨率各不小于 600x300（如果是png）'}</li>
                            <li className={styles.checkItem}>{'有一个明确的代表，无论文字或图形（你甚至可以只写个扩展名上去）'}</li>
                        </ul>
                        <p className={styles.sectionDesc}>
                            {'我们也建议您的扩展图可以：'}
                        </p>
                        <ul className={styles.checkList}>
                            <li className={styles.checkItem}>{'不单调'}</li>
                            <li className={styles.checkItem}>{'美观（参考TurboWarp及其他扩展库扩展）'}</li>
                            <li className={styles.checkItem}>{'有一个明确清晰的主题色而不是炸裂非主流的渐变和AI生成'}</li>
                        </ul>
                    </div>

                    {/* text.json */}
                    <div className={styles.stepsSection}>
                        <h3 className={styles.sectionTitle}>
                            {'text.json'}
                        </h3>
                        <p className={styles.sectionDesc}>
                            {'您可以复制这个示例并对其修改：'}
                        </p>
                        <div className={styles.codeBlock}>
                            <pre>{'{\n    "Name":{\n        "zh-cn":"扩展名"\n        ...更多语言\n    },\n    "Description":{\n        "zh-cn":"扩展描述"\n        ...更多语言\n    }\n}'}</pre>
                        </div>
                        <p className={styles.sectionDesc}>
                            {'这里不需要添加英文，英文添加于 main.js 中的 Name 和 Description。'}
                        </p>
                        <p className={styles.sectionDesc}>
                            {'我们硬性要求您的扩展格式包含以上二项，且 Name 和 Description 包含 zh-cn。这对国际化很有帮助。'}
                        </p>
                        <p className={styles.sectionDesc}>
                            {'我们不要求您的扩展内容包含国际化。'}
                        </p>
                    </div>

                    {/* Issues */}
                    <div className={styles.stepsSection}>
                        <h3 className={styles.sectionTitle}>
                            {'Issues'}
                        </h3>
                        <p className={styles.sectionDesc}>
                            {'如上，我们使用 Issues 来作为提交介质。我们将展开提交步骤。'}
                        </p>
                        <p className={styles.sectionDesc}>
                            <strong>{'1. 进入 Extensions 库——Issues'}</strong>
                        </p>
                        <p className={styles.sectionDesc}>
                            {'进入此链接 '}
                            <a
                                href="https://github.com/berry-editor/extensions/issues"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {'https://github.com/berry-editor/extensions/issues'}
                            </a>
                        </p>
                        <p className={styles.sectionDesc}>
                            <strong>{'2. 发送 Issue'}</strong>
                        </p>
                        <p className={styles.sectionDesc}>
                            {'点击 New issue。'}
                        </p>
                        <p className={styles.sectionDesc}>
                            {'在 Add a title 下面的输入框输入类似 Add new extension named "扩展名" 的文字让我们识别。'}
                        </p>
                        <p className={styles.sectionDesc}>
                            {'在 Add a description 处输入您想要告诉我们的信息，这不是必要的。'}
                        </p>
                        <p className={styles.sectionDesc}>
                            {'点击下方写着 Paste, drop, or click to add files 的按钮，导入您制作好的扩展文件（.zip）'}
                        </p>
                        <p className={styles.sectionDesc}>
                            {'等待导入完成，点击 Create！'}
                        </p>
                        <p className={styles.sectionDesc}>
                            <strong>{'完成！现在只需等待我们进行审核并回复您！'}</strong>
                        </p>
                    </div>

                    <div className={styles.linkCard}>
                        <img
                            className={styles.linkCardIcon}
                            src={githubIcon}
                            draggable={false}
                            alt="GitHub"
                        />
                        <div className={styles.linkCardContent}>
                            <div className={styles.linkCardTitle}>
                                {'提交扩展'}
                            </div>
                            <div className={styles.linkCardUrl}>
                                {'github.com/berry-editor/extensions/issues'}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.modalFooter}>
                    <button
                        className={`${styles.btn} ${styles.btnSecondary}`}
                        onClick={this.handleClose}
                    >
                        {'关闭'}
                    </button>
                    <button
                        className={`${styles.btn} ${styles.btnPrimary}`}
                        onClick={this.handleOpenIssues}
                    >
                        {'前往 GitHub'}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

BerryExtensionHubModal.propTypes = {
    onRequestClose: PropTypes.func.isRequired
};

export default BerryExtensionHubModal;